module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUCAIAAAARPMquAAAAYUlEQVQ4y2NgsJiOiTTCl//78eO6hgYQfb9+PaBsB1ZlONGooSPZUIuUdZgovGY3sqFlU49jVYYLMfx68gQr+nnvHsTQzwcP4lKDCzFAdFIX0cZQmnifJhE1mqNGDaWuoQD6ca+D73Ha6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/is.png
// module id = 305
// module chunks = 0